<div class="error-container">
  <div class="text-danger"><span class="fw-bold">Error:</span> {{ errorMessage }}</div>
</div>
